import { Home, Calculator, Target, Wallet, Settings } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router";
import { cn } from "@repo/share-log-web-utils";
import { useWorkspaceStore } from "@mobile/stores";

interface Tab {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  match: (pathname: string) => boolean;
}

function useTabs(): Tab[] {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const currentWorkspace = useWorkspaceStore((s) => s.currentWorkspace);
  const resolvedWorkspaceId = workspaceId ?? currentWorkspace?.id?.toString();
  const basePath = resolvedWorkspaceId
    ? `/workspace/${resolvedWorkspaceId}`
    : "";

  return [
    {
      label: "홈",
      icon: Home,
      path: basePath || "/",
      match: (pathname) =>
        pathname === basePath ||
        pathname === `${basePath}/` ||
        pathname === "/",
    },
    {
      label: "정산",
      icon: Calculator,
      path: `${basePath}/adjustment`,
      match: (pathname) => pathname.includes("/adjustment"),
    },
    {
      label: "목표",
      icon: Target,
      path: `${basePath}/spending-goals`,
      match: (pathname) => pathname.includes("/spending-goals"),
    },
    {
      label: "자산",
      icon: Wallet,
      path: `${basePath}/asset`,
      match: (pathname) => pathname.includes("/asset"),
    },
    {
      label: "설정",
      icon: Settings,
      path: `${basePath}/settings`,
      match: (pathname) => pathname.endsWith("/settings"),
    },
  ];
}

export function BottomTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = useTabs();

  return (
    <nav
      className="sticky bottom-0 z-20 flex shrink-0 border-t border-border bg-background"
      style={{
        height: `calc(56px + var(--safe-area-inset-bottom))`,
        paddingBottom: "var(--safe-area-inset-bottom)",
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        const Icon = tab.icon;

        return (
          <button
            key={tab.label}
            type="button"
            className={cn(
              "flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5",
              isActive ? "text-primary" : "text-muted-foreground",
            )}
            onClick={() => navigate(tab.path)}
          >
            <Icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
